import React from 'react'
import { makeStyles } from '@material-ui/core'
import { VerbalColorType } from 'foundations-library/types'
import { getVerbalColors } from 'helpers'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    const verbalColors = getVerbalColors(colors)

    return {
        section: {
            borderRadius: 6,
            padding: '13px 15px',
            background: ({ bgColor }) => verbalColors[bgColor] || bgColor,
            '& .label-in-border': {
                backgroundColor: ({ bgColor }) => `${verbalColors[bgColor] || bgColor} !important`
            }
        }
    }
}

const useStyles = makeStyles(jss)

type PropsType = Omit<React.ComponentPropsWithoutRef<'div'>, 'color'> & {
    color?: VerbalColorType | string
}

/**
 *
 */
const EmphasizedSection = ({
    children,
    color = 'neutral-50',
    ...props
}: PropsType): JSX.Element => {
    const styles = useStyles({ bgColor: color })
    return <div {...props} className={`${styles.section} ${props.className || ''}`}>
        {children}
    </div>
}

export default EmphasizedSection
